/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedPersonalizedFilterToast_shippingFilters$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespCollectionsComponents_shippingFilters$ref: FragmentReference;
export type SbRespCollectionsComponents_shippingFilters = $ReadOnlyArray<{|
  +$fragmentRefs: SbSharedPersonalizedFilterToast_shippingFilters$ref,
  +$refType: SbRespCollectionsComponents_shippingFilters$ref,
|}>;
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespCollectionsComponents_shippingFilters",
  "type": "ShippingFilterType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedPersonalizedFilterToast_shippingFilters",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '441114fb61af5387249e29d8712705a4';
module.exports = node;
